<template>
    <Modal
    v-model="visible"
    title="开票资料"
    :footer-hide="true"
    :mask-closable="false"
    width="1000"
    >
    <div class="content-box">
      <div class="content-title">开票资料</div>
      <div class="row">开票抬头：梧桐树保险经纪有限公司</div>
      <div class="row">纳税人识别号：91440000796298438D</div>
      <div class="row">地 址：武汉市江汉区王家墩中央商务区泛海国际SOHO城3,4,6栋6号楼单元7层2-5室、25层1-4号房</div>
      <div class="row">电 话：027-83668382</div>
      <div class="row">开户行：上海浦东发展银行武汉分行营业部</div>
      <div class="row">帐 号：70160078801100000129</div>
    </div>
    <div class="info-box">
      <div class="info-title">开票类目</div>
      <div class="row" style="margin-bottom:6px;">A：全国经代公司开票类目：经纪代理服务*服务费/经纪代理服务*手续费；</div>
      <div class="row">B：区域经代公司开票类目：</div>
      <div class="row" style="margin-left:12px;">（1）如开展线上引流业务，需开具：现代服务*服务费/其他现代服务*服务费</div>
      <div class="row" style="margin-bottom:6px;margin-left:12px;">（2）如只开展线下经代业务，则开具：经纪代理服务*服务费/经纪代理服务*手续费</div>
      <div class="row">C：引流机构开票类目：现代服务*服务费、其他现代服务*服务费"</div>
      <!-- <div class="text" style="color:#fd0000;">注意：发票类型需为增值税专用发票</div> -->
    </div>
    <img src="@static/images/invoice.png" alt="">
    <div class="content-box">
      <div class="content-title">邮寄信息</div>
      <div class="row">收件信息：武汉市江汉区泛海国际SOHO城第6栋7楼</div>
      <div class="row">组织：财务机构组 </div>
      <div class="row">电话：027-83868566</div>
      <div class="row">邮编：430000</div>
    </div>
    </Modal>
</template>

<script>
export default {
    data(){
        return{
            visible:false,
        }
    },
    methods:{
        open(){
            this.visible=true;
        }
    }
}
</script>

<style lang="scss" scoped>
.content-box {
    margin-bottom: 10px;
    .content-title {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      margin-bottom: 10px;
      padding-left: 10px;
      position: relative;
      &::before {
        content: "";
        width: 3px;
        height: 14px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background: #F47900;
        border-radius: 6px;
      }
    }
    .row {
      font-size: 14px;
      color: #666;
      margin-bottom: 7px;
    }
  }
  .info-box {
    background: #F8F7F7;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 30px;
    .info-title {
      font-size: 14px;
      color: #666;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p,
    .row {
      font-size: 12px;
      color: #666;
    }
    p {
      padding-left: 1em;
    }
    .text {
      font-size: 12px;
      color: #666;
      font-weight: bold;
      margin-top: 8px;
    }
  }
</style>